import { uniqBy } from 'lodash';
import type { DocumentField } from 'types/repository.types';
import type { ITax } from 'types/taxes.types';

export const getTaxItemTaxMFDocuments = (tax: ITax): DocumentField[] => {
  return uniqBy(
    tax?.documents
      ?.map((document) =>
        document?.documentFields?.filter(
          (documentField: DocumentField) =>
            documentField?.referenceType == 'tax' &&
            documentField?.value?.type === tax.type,
        ),
      )
      ?.flat() || [],
    '_id',
  );
};
const useTaxItemTaxMFDocuments = (tax: ITax): DocumentField[] => {
  return getTaxItemTaxMFDocuments(tax);
};

export default useTaxItemTaxMFDocuments;
